const BorderBox = ({
  children,
  noPadding,
  padding,
  overflow,
  onClick,
  className,
}) => {
  // Check if className contains a height class
  const hasCustomHeight = className && /h-\w+/.test(className);

  return (
    <div
      className={`rounded-2xl bg-lz-paper dark:bg-lz-charcoal border border-lz-paper-border dark:border-lz-charcoal-border no-scrollbar ${
        noPadding ? "p-0" : padding ? padding : "p-4"
      } ${overflow ? "overflow-y-auto" : ""} ${
        hasCustomHeight ? "" : "h-full"
      } ${className || ""}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default BorderBox;
